import { ContractLinkScreen } from '~/utils/logger';
import { ConsentLink } from './consent-link.component';

export const CreditCheckConsentLink = ({
  notes,
  linkcolor,
  screen,
}: {
  notes: string;
  linkcolor?: 'primary' | 'secondary';
  screen: ContractLinkScreen;
}) => (
  <ConsentLink
    labelText="Credit Check Consent"
    headerText="Credit Check Consent"
    bodyContent={notes}
    linkcolor={linkcolor}
    screen={screen}
  />
);
